module.exports = __webpack_public_path__ + "img/GAME_LINKRIBBON1.3b108610.jpg";